import { HomePage } from "./../home/home";
import { TranslateService } from "@ngx-translate/core";
import { PlazaSelectPlanPage } from "./../plaza-select-plan/plaza-select-plan";
import { Storage } from "@ionic/storage";
import { Http, RequestOptions, Headers } from "@angular/http";
import { ServiceProvider } from "./../../providers/service/service";
import { SelectSearchableComponent } from "ionic-select-searchable";
import { ViewHeaderPage } from "./../view-header/view-header";
import { Component } from "@angular/core";
import {
  IonicPage,
  LoadingController,
  NavController,
  NavParams,
} from "ionic-angular";

class Shop {
  public id: number;
  public name: string;
}
class Discount {
  public id: number;
  public name: string;
}
@IonicPage()
@Component({
  selector: "page-plaza-select-plan-rent",
  templateUrl: "plaza-select-plan-rent.html",
})
export class PlazaSelectPlanRentPage {
  code: string = "";
  space: any;
  shops: Shop[];
  shop: Shop;
  discounts: Discount[];
  discount: Discount;
  discountVal: number | null = null;
  shopVal: number | null = null;
  desc: any = { decoration: "", rental_fee: "", cost: "" };
  plaza_id = "";
  plaza_name = "";
  public qrData = null;
  public qrDetail = null;
  // public createdCode: string = null;
  theme = 1;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private storage: Storage,
    private services: ServiceProvider,
    private http: Http,
    private translateService: TranslateService,
    private loadingCtrl: LoadingController
  ) {
    if (this.navParams) {
      this.space = this.navParams.data.space.space_no;
    }
  }

  /** getCode for new function ##เช่าพื้นที่ 1 */
  getCode() {
    // this.code = "X2FGJ4";
    const loader = this.loadingCtrl.create({
      content: "Loading...",
    });

    loader.present();

    this.storage.get("token").then((token) => {
      var link = this.services.URLPlazaRentSpaceCode;
      var headers = new Headers();
      headers.append("Accept", "application/json");
      headers.append("Authorization", "Bearer " + token);
      const requestOptions = new RequestOptions({ headers: headers });

      this.http
        .post(
          link,
          {
            space_id: this.space,
            shop_id: this.shopVal,
            discount: this.discountVal,
          },
          requestOptions
        )
        .map((res) => res.json())
        .subscribe(
          (data) => {
            this.code = data.code;
            loader.dismiss();
          },
          (error) => {
            var response = JSON.parse(error._body);

            this.translateService.get(response.message).subscribe((value) => {
              this.services.presentToast(value);
            });
            loader.dismiss();
          }
        );
    });
  }

  shopChange(event: { component: SelectSearchableComponent; value: any }) {
    this.storage.get("discount").then((discount) => {
      let res = event.value;
      this.code = "";
      this.shopVal = res.shop_id;

      if (discount) {
        this.desc.decoration = this.services.currencyFormat(res.decoration);
        this.desc.rental_fee = this.services.currencyFormat(res.rental_fee);
        let total =
          parseFloat(res.decoration) +
          parseFloat(res.rental_fee) +
          parseFloat(res.cost) * parseFloat(res.max_stock) +
          parseFloat(res.rental_fee) * (parseFloat(discount) / 100);
        this.desc.cost = this.services.currencyFormat(total);

        this.qrData = {
          plaza_id: this.plaza_id,
          plaza_name: this.plaza_name,
          space_no: this.space,
          shop_id: res.shop_id,
          shop_name: res.shop_name,
          discount: discount,
          action: "rent",
        };

        this.qrDetail = {
          plaza_id: this.plaza_id,
          plaza_name: this.plaza_name,
          space_no: this.space,
          shop_id: res.shop_id,
          shop_name: res.shop_name,
          decoration: res.decoration,
          rental_fee: res.rental_fee,
          selling_price: res.selling_price,
          cost: res.cost,
          demand: res.demand,
          max_stock: res.max_stock,
          discount: discount,
        };

        this.storage.set("qrData", this.qrDetail);
        // this.createdCode = JSON.stringify(this.qrData);
      } else {
        this.desc.decoration = this.services.currencyFormat(res.decoration);
        this.desc.rental_fee = this.services.currencyFormat(res.rental_fee);
        let total =
          parseFloat(res.decoration) +
          parseFloat(res.rental_fee) +
          parseFloat(res.cost) * parseFloat(res.max_stock);
        this.desc.cost = this.services.currencyFormat(total);

        this.qrDetail = {
          plaza_id: this.plaza_id,
          plaza_name: this.plaza_name,
          space_no: this.space,
          shop_id: res.shop_id,
          shop_name: res.shop_name,
          decoration: res.decoration,
          rental_fee: res.rental_fee,
          selling_price: res.selling_price,
          cost: res.cost,
          demand: res.demand,
          max_stock: res.max_stock,
          discount: "0",
        };

        this.storage.set("qrData", this.qrDetail);
        // console.log("qrDetail=", this.qrDetail);
      }
    });
  }

  discountChange(event: { component: SelectSearchableComponent; value: any }) {
    this.code = "";
    let discount = event.value.discount_id;
    this.discountVal = event.value.discount_id;
    this.storage.set("discount", discount);

    this.storage.get("qrData").then((data) => {
      if (data) {
        let total =
          parseFloat(data.decoration) +
          parseFloat(data.rental_fee) +
          parseFloat(data.cost) * parseFloat(data.max_stock) +
          parseFloat(data.rental_fee) * (parseFloat(discount) / 100);
        this.desc.cost = this.services.currencyFormat(total);

        this.qrData = {
          plaza_id: this.plaza_id,
          plaza_name: this.plaza_name,
          space_no: this.space,
          shop_id: data.shop_id,
          shop_name: data.shop_name,
          discount: discount,
          action: "rent",
        };

        this.qrDetail = {
          plaza_id: this.plaza_id,
          plaza_name: this.plaza_name,
          space_no: this.space,
          shop_id: data.shop_id,
          shop_name: data.shop_name,
          decoration: data.decoration,
          rental_fee: data.rental_fee,
          selling_price: data.selling_price,
          cost: data.cost,
          max_stock: data.max_stock,
          discount: discount,
        };

        this.storage.set("qrData", this.qrDetail);
        // this.createdCode = JSON.stringify(this.qrData);
      }
    });
  }

  async ionViewDidLoad() {
    console.log("เช่าพื้นที่ 1");
    this.theme = await this.storage.get("theme");

    // this.storage.get("discount").then(discount=>
    // {
    //     if(discount)
    //     {
    //       this.storage.set("discount", discount);
    //     }
    //     else
    //     {
    //       this.storage.set("discount", "0");
    //     }

    // });

    this.storage.get("info").then((info) => {
      this.plaza_id = info.team.plaza_id;
      this.plaza_name = info.team.plaza_name;
    });

    this.storage.get("token").then((token) => {
      var link = this.services.URLShops;
      var headers = new Headers();
      headers.append("Accept", "application/json");
      headers.append("Authorization", "Bearer " + token);
      const requestOptions = new RequestOptions({ headers: headers });

      this.http
        .get(link, requestOptions)
        .map((res) => res.json())
        .subscribe(
          (data) => {
            this.shops = data;
          },
          (error) => {
            var response = JSON.parse(error._body);

            this.translateService.get(response.message).subscribe((value) => {
              this.services.presentToast(value);
            });
          }
        );

      var link2 = this.services.URLDiscount;

      this.http
        .get(link2, requestOptions)
        .map((res) => res.json())
        .subscribe(
          (data) => {
            this.discounts = data;
          },
          (error) => {
            var response = JSON.parse(error._body);

            this.translateService.get(response.message).subscribe((value) => {
              this.services.presentToast(value);
            });
          }
        );
    });
  }

  copyToClipboard = (): boolean => {
    const el = document.createElement("textarea");
    el.value = this.code;
    el.setAttribute("readonly", "");
    // el.style = { position: "absolute", left: "-9999px" };
    document.body.appendChild(el);

    el.select();
    // Copy text to clipboard
    try {
      const successful = document.execCommand("copy");
      if (successful) {
        document.body.removeChild(el);
        // copy to clipboard
        this.services.presentToast("copied!");
        return true;
      }
    } catch (err) {
      return false;
    }

    return false;
  };

  backPage() {
    this.storage.remove("discount");
    this.storage.remove("qrData");
    this.navCtrl.push(PlazaSelectPlanPage);
  }
  openHeadPage() {
    this.navCtrl.push(ViewHeaderPage);
  }

  homePage() {
    this.navCtrl.setRoot(HomePage);
  }
}



// WEBPACK FOOTER //
// ./src/pages/plaza-select-plan-rent/plaza-select-plan-rent.ts